<div>
    <ng-template app-plugin-view></ng-template>
</div>
